import { 
    getEventOrderByClient,
    clientEventOrderTemplate,
    createEventOrder,
  } from "@/http/customer/customer";
  
  export default {
    namespaced: true,
    state: {
        eventOrders: [],
        eventOrdersTemplate: {},
    },
    actions: {
      async getEventOrderByClientAction({ commit }, payload) {
        const response = await getEventOrderByClient(payload);
        commit("SET_CLIENT_EVENT_ORDERS", response.data);
        return response;
      },
      async clientEventOrderTemplateAction({ commit }, payload) {
        const response = await clientEventOrderTemplate(payload);
        commit("SET_EVENT_ORDER_TEMPLATE", response.data);
        return response;
      },
      async createEventOrderAction(_, payload) {
        return await createEventOrder(payload);
      },
      
    },
    mutations:{
        SET_CLIENT_EVENT_ORDERS(state, payload) {
            state.eventOrders = payload;
          },
        SET_EVENT_ORDER_TEMPLATE(state, payload) {
            state.eventOrdersTemplate = payload;
          },
    },
    getters:{
        GetClientEventOrders(state) {
            return state.eventOrders;
          },
        GetEventOrdersTemplate(state) {
            return state.eventOrdersTemplate;
          },
    }
  };
  